// extracted by mini-css-extract-plugin
export default {"card":"Card_card__ErVX3","button_download":"Card_button_download__qtifF","button_add":"Card_button_add__E3-Dw"};